import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { useGetOrganizations } from '@/hooks/useGetOrganizations';
import * as S from '@/components/Settings/DataExtraction/styles';

const { useFormInstance } = Form;

export function OrganizationFormItem() {
	const form = useFormInstance();
	const organizations = useGetOrganizations();

	function handleOnChange(): void {
		form.setFieldValue(['general_information', 'company_id'], undefined);
		form.setFieldValue(['general_information', 'sector_id'], undefined);
		form.setFieldValue(['general_information', 'line_id'], undefined);
		form.setFieldValue(['general_information', 'workstation_id'], undefined);
	}

	return (
		<S.CustomFormItem
			name={['general_information', 'organization_id']}
			label={I18n.get('Company')}
			labelCol={{ span: 24 }}
			rules={[{ required: true, message: I18n.get('Company is required') }]}
		>
			<SelectOptions
				allowClear
				onChange={handleOnChange}
				options={organizations.data}
				placeholder={I18n.get('Company')}
				loading={organizations.isFetching}
			/>
		</S.CustomFormItem>
	);
}
